<template>
    <TabWrapper @change="change">
        <Headline>Zones</Headline>
        <span class="description">
            Aktivieren bzw. Deaktivieren der Werbeausspielung auf <b>einzelnen Zonen</b>.
        </span>
        <v-row>
            <v-col class="mt-8" cols="12" md="4" v-for="sitetype in typesAndZones"
                   :key="'sitetype_'+sitetype.SitetypeId">
                <label>Sitetype</label><span class="sitetype_title">{{ sitetype.Name }}</span>
                <v-row class="mt-2" v-if="sitetype.Zones.length === 0">
                    <v-col style="font-size: 1.1em">Keine Zonen</v-col>
                </v-row>
                <v-row v-for="zone in sitetype.Zones" :key="'zone_'+zone.ZoneId" no-gutters>
                    <v-col>
                        <Toggle v-model="zone.Status" :hide-details="true" :true-value="0" :false-value="1"
                                :label="zone.Name + ' deaktivieren'"
                                @input="updateDisabledZones(zone)"></Toggle>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <Button class="mt-8" @click="submit" :color="ada.pink"
                        :loading="loading">
                    Speichern & Deployen
                </Button>
            </v-col>
        </v-row>
    </TabWrapper>
</template>

<script>
import TabWrapper from "../../EmergencyStop/Tabs/TabWrapper";
import ada from "../../../scss/ada_colors.scss";
import Headline from "../../../components/Headline";
import Toggle from "../../../components/buttons/Toggle";
import Button from "../../../components/buttons/Button";

export default {
    name: "Zones",
    components: {Button, Toggle, Headline, TabWrapper},
    props: ['loading'],
    data: () => {
        return {
            typesAndZones: null,
            zoneIsDisabled: {},
            ada
        }
    },
    mounted() {
        if (this.siteDetails) {
            this.init();
        }
        this.$emit('activeComponent', this);
    },
    computed: {
        siteDetails() {
            return this.$store.state.emergency.siteDetails;
        },
        store_typesAndZones() {
            return this.siteDetails ? this.siteDetails.TypesAndZones : [];
        },
        activeTab() {
            return this.$store.state.emergency.activeTab;
        }
    },
    methods: {
        init() {
            this.typesAndZones = JSON.parse(JSON.stringify(this.store_typesAndZones))
        },
        submit() {
            this.$emit('submit', this);
        },
        change() {
            if (this.$store.state.emergency.previousTab === this.$options._componentTag) {
                this.$emit('change', this);
            }
        },
        dataChanged() {
            this.zoneIsDisabled = {};
            let changed = false;
            for (let i = 0; i < this.typesAndZones.length; i++) {
                let sitetype = this.typesAndZones[i];
                for (let j = 0; j < sitetype.Zones.length; j++) {
                    let zone = sitetype.Zones[j];
                    if (zone.Status !== this.store_typesAndZones[i].Zones[j].Status) {
                        if (!changed) changed = true;
                        if (zone.Status === 0) {
                            this.zoneIsDisabled[zone.ZoneId] = 1;
                        }
                    }
                }
            }
            return changed;
        },
        updateDisabledZones(zone) {
            this.$store.commit('emergency/updateDisabledZones', zone);
        }
    },
    watch: {
        siteDetails() {
            if (this.siteDetails) {
                this.init();
            }
        },
        activeTab() {
            if (this.activeTab === this.$options._componentTag) {
                this.$emit('activeComponent', this);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.sitetype_title {
    font-weight: bold;
    font-size: 1.1em;
}

label {
    margin-right: 10px;
    background: $ada_blue;
    padding: 5px 10px;
    border-radius: 4px;
    color: #fff;
    text-transform: uppercase;
    font-weight: 500;
}

</style>